/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Version } from '@angular/core';
/**
 * @deprecated use \@angular/common/http instead
 */
export var /** @type {?} */ VERSION = new Version('5.2.8');
//# sourceMappingURL=version.js.map